<template>
  <v-dialog
    hide-overlay
    :overlay-opacity="0"
    transition="fade-transition"
    persistent
    ref="dialog"
    :value="!!isOpen"
    absolute
  >
    <div class="card-overlay" @click="onOverlayClick"/>

    <v-card style="width: 560px" class="" v-if="isOpen">
<!--      <template-->
<!--        v-if="selectedTheme !== undefined && Object.keys(selectedTheme).length && selectedTheme.screenshot_url"-->
<!--      >-->
<!--        <v-img-->
<!--          height="285px"-->
<!--          width="100%"-->
<!--          position="top center"-->
<!--          :src="selectedTheme.screenshot_url"-->
<!--        />-->
<!--        <v-divider />-->
<!--      </template>-->

      <v-card-title class="pb-0 flex justify-space-between align-center">
        <h4>
          {{ $t("heading.onboarding.transferDomain.title") }}
        </h4>
        <v-btn x-small icon :disabled="loading" @click="closeModal" class="close-model">
          <v-icon>$close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text height="800px" class="px-10 pt-8">
        <h6 class="p-2 font-weight-light">
          <i18next
            :translation="$t('heading.onboarding.transferDomain.subtitle')"
          >
            <template #domain><span class="font-weight-600">{{ domain }}</span></template>
          </i18next>
        </h6>

        <template v-if="canSelectedServiceTransferDomain()">
          <p class="p-3 mt-2">
            <i18next
              :translation="$t('heading.onboarding.transferDomain.message.possible')"
            >
              <template #recordType><span class="font-weight-800">{{ domainVerificationRecord.type }}</span>
              </template>
              <template #domain><span class="font-weight-800">{{ domain }}</span></template>
            </i18next>
          </p>
          <div class="recovery-code-box">
            {{ domainVerificationRecord.content }}
            <copy-text-button
              :text="domainVerificationRecord.content"
              :color="'primary'"
              size="24"
            />
          </div>
        </template>
        <template v-else>
          <p class="p-3 mt-2">
            {{ $t('heading.onboarding.transferDomain.message.impossible') }}
          </p>
        </template>
      </v-card-text>
      <v-card-actions class="d-flex flex-column pb-6 px-10 pt-2 mt-4">
        <v-btn
          v-if="isDomainTransferEnabled"
          x-large
          elevation="0"
          color="primary"
          block
          :disabled="loading"
          @click="$emit('transfer-domain')"
          :loading="loading"
        >
          <template v-if="this.hasSelectedServiceInstantVerificationEnabled()">
            <span>{{ $t("button.continue") }}</span>
            <v-icon size="24" class="ml-2">$arrowright</v-icon>
          </template>
          <template v-else-if="hasSelectedServiceAskForSiteName()">
            <span>{{ $t("button.website.set") }}</span>
            <v-icon size="24" class="ml-2">$arrowright</v-icon>
          </template>
          <template v-else>
            <span>{{ $t("button.transferNow") }}</span>
            <v-icon size="24" class="ml-2">$arrowright</v-icon>
          </template>
        </v-btn>
        <v-btn
          v-if="services.length > 1"
          :disabled="loading"
          @click="onChangeServiceClick"
          x-large
          elevation="0"
          class="mx-0 mt-2"
          color="gray"
          text
          block
        >
          <span class="p-1 font-weight-light gray--text text--darken-1">
            {{ $t("button.service.change") }}
          </span>
        </v-btn>
        <v-btn
          v-else
          :disabled="loading"
          x-large
          elevation="0"
          class="mx-0 mt-2"
          color="gray"
          text
          block
          @click="closeModal"
        >
          <span class="p-1 font-weight-light gray--text text--darken-1">
            {{ $t("button.back") }}
          </span>
        </v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
import CopyTextButton from "../../components/buttons/CopyTextButton.vue";
import OnboardingSelectedServiceMixin from "../../mixins/OnboardingSelectedServiceMixin";

export default {
  name: "OnboardingDomainTransferModal",
  components: {CopyTextButton},
  mixins: [OnboardingSelectedServiceMixin],
  props: {
    isOpen: [Boolean, String],
    loading: Boolean,
    selectedTheme: Object,
    services: Array,
    selectedService: {
      type: Object,
      default: () => {
      },
    },
    domain: String,
    domainVerificationRecord: Object,
  },
  data() {
    return {
      isDomainVerified: false,
    }
  },
  mounted() {
    window.addEventListener('beforeunload', this.handleBeforeUnload);
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
  },
  methods: {
    closeModal() {
      if (!this.loading) {
        this.$emit('remove-modal');
      }
    },
    onOverlayClick() {
      if (!this.loading && this.$refs.dialog) {
        this.$refs.dialog.animateClick();
      }
    },
    onChangeServiceClick() {
      if (!this.loading) {
        this.$emit('change-service-button-clicked');
      }
    },
    handleBeforeUnload(e) {
      if (!this.loading) {
        return;
      }
      const message = 'Installation is in progress. Leaving the page may cause the process to fail.';
      (e || window.event).returnValue = message;
      return message;
    },
  },
  computed: {
    isDomainTransferEnabled() {
      return this.selectedService?.onboarding.domain_transfer_enabled;
    },
  },
  watch: {
    isOpen: function (value) {
      value
        ? this.$store.dispatch("lockBodyScroll")
        : this.$store.dispatch("unlockBodyScroll");
    },
  },
}
</script>


<style lang="scss" scoped>
.recovery-code-box {
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  height: 60px;
  color: var(--v-primary-base);
  background: rgba(7, 192, 126, 0.05);
  border-radius: 6px;
  text-transform: uppercase;
  font-weight: $font-weight-bold;
  word-wrap: anywhere;
  padding: 8px;
  min-height: 80px !important;
}

.main-warning-message {
  background: var(--v-primary-lighten4);
  border-radius: 6px;

  h5 {
    margin: 0;
    font-size: 1.1em;
    color: var(--v-primary-base);

    strong {
      color: var(--v-primary-darken1) !important;
    }
  }
}

.v-dialog__content::v-deep {
  .v-dialog {
    overflow-y: auto;
    overflow-x: hidden;
  }
}

.close-model {
  position: absolute;
  top: -40px;
  right: -8px;
}

.v-card::v-deep {
  .v-card__text {
    -webkit-line-clamp: unset !important;
  }

  @media (max-width: 480px) {
    .v-card__text,
    .v-card__actions {
      padding-left: 24px !important;
      padding-right: 24px !important;
    }
  }
}

.alert-box {
  width: 100%;
  min-width: 100%;
  padding: 16px;
  text-align: center;
  border-radius: 8px;

  &.ok {
    background: var(--v-success-lighten5);
    color: var(--v-success-base);
  }

  &.alert {
    background: var(--v-error-lighten5);
    color: var(--v-error-base);
  }
}

</style>